import RadioGroup from '@components/molecules/RadioGroup';
import { YoungConductorCoverage } from '@graphql/generated';
import {
  QuoteInitialForm,
  YoungConductorFormResult
} from '@lib/data/typesQuestions';
import GridBox from 'components/atoms/GridBox';
import { FC } from 'react';
import { useForm } from 'react-hook-form';
import styled from 'styled-components';

const Form = styled.form``;

interface FormResult {
  youngCoverage: YoungConductorCoverage;
}

interface Props {
  onSubmit: (data: YoungConductorFormResult) => void;
  item: QuoteInitialForm;
}

const YoungConductorForm: FC<Props> = ({ onSubmit, item }) => {
  const { register, handleSubmit, errors } = useForm<FormResult>();

  return (
    <Form
      onSubmit={handleSubmit(({ youngCoverage }) => {
        if (item.vehicle)
          onSubmit({
            youngCoverage,
          });
      })}
    >
      <GridBox justifyContent="center">
        <GridBox width={[1, 0.5, 0.5]}>
          <RadioGroup
            inputRef={register({ required: 'Escolha uma das opções' })}
            name="youngCoverage"
            errorMessage={errors.youngCoverage?.message}
            onSelected={(value) => {
              if (item.vehicle)
                onSubmit({
                  youngCoverage: value as YoungConductorCoverage,
                });
            }}
            options={[
              {
                label: 'Não',
                value: YoungConductorCoverage.Nop,
              },
              {
                label: 'Sim mas não dirigem',
                value: YoungConductorCoverage.DontDrive,
              },
              {
                label: 'Sim, com uma mulher que dirige o veículo',
                value: YoungConductorCoverage.Female,
              },
              {
                label: 'Sim, com um homem que dirige o veículo',
                value: YoungConductorCoverage.Male,
              },
              {
                label:
                  'Sim, com pessoas de ambos os sexos que dirigem o veículo',
                value: YoungConductorCoverage.Both,
              },
            ].map((o) => {
              if (o.value === item.youngCoverage)
                return { ...o, checked: true };

              return o;
            })}
          />
        </GridBox>
      </GridBox>

    </Form>
  );
};

export default YoungConductorForm;
